import { createTheme, ThemeProvider } from "@mui/material";
import { TestDataProvider } from "context/TestDataContext";
import { LanguageProvider } from "i18n/LanguageContext";
import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Route, Routes } from "react-router-dom";
import NewScoreSheet from "screens/NewScoreSheet";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import HomeDash from "./screens/Homescreen";
import Login from "screens/Login";
import AuthGuard from "components/AuthGuard";
import { installWebAPIIfNeeded } from "utils/webAPI";

installWebAPIIfNeeded();

export const theme = createTheme({
  overrides: {
    MuiAppBar: {
      root: {
        elevation: 10,
      },
    },
    MuiButton: {
      root: {
        borderRadius: 28,
      },
      contained: {
        boxShadow: "none",
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1536,
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    button: {
      textTransform: "none",
    },
    h4: {
      fontWeight: 300,
    },
    h5: {
      fontWeight: 350,
      fontStyle: "light",
    },
    h2: {
      fontWeight: 100,
    },
  },
  palette: {
    primary: {
      main: "#2051A4",
    },
    secondary: {
      main: "#ADE3D6",
    },
    background: {
      default: "#ffffff",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <TestDataProvider>
          <HashRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/newscoresheet" element={<AuthGuard><NewScoreSheet /></AuthGuard>} />
              <Route path="/" element={<AuthGuard><HomeDash /></AuthGuard>} />
            </Routes>
          </HashRouter>
        </TestDataProvider>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
